import styled from 'styled-components';

import Button from 'components/Buttons/Button';

export const SectionContainer = styled.div`
  padding: 16px 16px 32px 16px;
`;

export const AddNewExpense = styled(Button)`
  margin-top: 25px;
  font-size: 16px;
  font-weight: 600;
`;
